<script setup lang="ts">
import SideBarMenu from '@/components/dashboard/sidebar-menu/SideBarMenu.vue'
import Workspace from '@/components/dashboard/Workspace.vue'
</script>

<template>
  <div class="container-outer">
    <SideBarMenu class="side-bar" />
    <Workspace class="workspace" />
  </div>
</template>

<style scoped>
.container-outer {
  display: grid;
  grid-template-columns: minmax(16.25rem, 15%) 1fr;
  grid-template-rows: 1fr;
  min-block-size: 100vh;
  min-block-size: 100dvh;
  grid-template-areas: 'sidebar workspace';
}

.side-bar {
  grid-area: sidebar;
  position: fixed;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  z-index: 100;
}

.side-bar::-webkit-scrollbar {
  display: none;
}

.workspace {
  grid-area: workspace;
}
</style>
